import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service'; // adjust as needed

@Injectable({
  providedIn: 'root'
})
export class VendorStepGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    let user: any = localStorage.getItem('user')
    let Details = JSON.parse(user)
    console.log("Details ", Details);
    
    // Allow only if step is 3 or 4, and user is a vendor
    if ((Details?.role === 'vendor' || Details?.role === 'manager')  && (Details?.step === 3 || Details?.step === 4)) {
      return true;
    }
    // Redirect for step 1 or 2 or other roles
    // this.router.navigate(['/unauthorized']); // or another appropriate page
    return false;
  }
}
